export class GridPreference {
    appUser?: object;
    appUserId: any;
    gridName: string;
    preference: string;
    wrapHeader: boolean;
    isSession: boolean;
    description: string;
    geCount: number;
    sessionDescription: string;
    sharedByUserId: any;
}